interface Node {
  content?: Node[];
  type: string;
}

const NODE_TYPES_WITHOUT_CONTENT = [
  "image",
  "file",
  "embed",
  "mention",
  "horizontalRule",
];

export const isValidTiptapBody = (tiptap_body?: { body?: Node }): boolean => {
  if (tiptap_body?.body?.content?.length) {
    return tiptap_body.body.content.some(
      (content: Node) =>
        !!content.content || NODE_TYPES_WITHOUT_CONTENT.includes(content.type),
    );
  }
  return false;
};
